import React from 'react'
import { Box, IconButton, styled, Typography, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { tokens } from './../../../layout/theme';

function Tab({ data, onClose, onActive }) {
    const { id, title, closable, active } = data
    const theme = useTheme()
    const colors = tokens(theme.palette.mode);
    const TabContainer = styled(Box)(({ theme }) => ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-around',
        gap: '10px',
        backgroundColor: theme.palette.background.default,
        border: `1px solid ${theme.palette.background.gray}`,
        borderRadius: '5px 5px 0px 0px',
        padding: '0px 8px',
        cursor: 'pointer',
        height: '40px'

    }))
    const handleSetActive = (id) => {
        if (active) return;
        onActive(id)
    }
    return (
        <TabContainer key={id} onClick={() => handleSetActive(id)} sx={{ backgroundColor: active ? colors.primary[200] : theme.palette.background.default }}>
            <Typography sx={{ color: theme.palette.text.default }}>{title}</Typography>
            {closable ? (<IconButton onClick={() => onClose(id)}>
                <CloseIcon sx={{ color: theme.palette.danger.main }} />
            </IconButton>) : (<Box sx={{ widht: '20px', height: '20px', margin: '10px' }} />)}
        </TabContainer>
    )
}

export default Tab